/** The page back at its top on a new screen. jsdom (the tests) has no scrolling and only logs "not implemented". */
export function scrollPageTop(): void {
    if (typeof window.scrollTo !== "function" || /jsdom/i.test(window.navigator.userAgent)) return;
    window.scrollTo(0, 0);
}
